import React, { useCallback, useState } from 'react';
import { Query } from '../_common';
import { startCase } from 'lodash';
// import { ModalForm } from './interface';
import { GET_ALL_PROPPANTS } from '../../graphql/client/queries';
import { DELETE_PROPPANT, ADD_PROPPANT, EDIT_PROPPANT } from '../../graphql/client/mutations';
import { useMutation, useQuery } from '@apollo/client/react';
import { PermissionEnum } from '../../types/PermissionEnum';
import { useAuthContext } from '../Auth/AuthProvider';
import { Alert } from 'react-bootstrap';

import {  ToastContainer, toast } from 'react-toastify';
import {toastOpt} from '../../utils/helpers/toastHelper'

import { GetAllProppants, GetAllProppants_getAllProppants as Proppant } from '../../types/schemaTypes';

import { Error, Loading, GridView } from '../_common';


// import { useStoreContext } from '../App/StoreProvider';
// import { useAuthContext } from '../Auth/AuthProvider';
// import { PermissionEnum } from '../../types/PermissionEnum';
import AddEditProppant from './AddEditProppant';
// const PAGE_SIZE = 50;
const toasterOptions = { duration: 2500 };
const Messages = {
    create: 'Proppant created successfully',
    update: 'Proppant updated successfully',
    delete: 'Proppant deleted successfully',
};
const ErrorMessages = {
    create: 'Failed to create proppant',
    update: 'Failed to update proppant',
    delete: 'Failed to delete proppant',
};

const Proppants = (): React.ReactElement => {
    // const canEditUsers = useAuthContext().userHasPermission(PermissionEnum.EditCustomer);
    // const [state] = useStoreContext();
    const [createDialogVisible, setCreateDialogVisible] = useState(false);
    const canEditProppant = useAuthContext().userHasPermission(PermissionEnum.EditProppant);
    const canEditDelete = useAuthContext().userHasPermission(PermissionEnum.DeleteProppant);

    const { loading, error, data, refetch } = useQuery<GetAllProppants>(GET_ALL_PROPPANTS);

    const [form, setForm] = useState(null);
    const [searchText, setSearchText] = useState('');
    const [tabTitle, setTabTitle] = useState(document.title);
    document.title = 'SBS';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getColums = (record: any) => {
        const excludeKeys = ['proppantId', '__typename'];

        const columns = Object.keys(record)
            .filter(column => !excludeKeys.includes(column))
            .map(column => {
                return {
                    key: column,
                    title: startCase(column),
                };
            });

        columns.push({ key: '', title: 'Actions' });
        return columns;
    };

    const renderToast = (message, type = 'info') => {
        interface ToastProps {
            onClose?: () => void;
        }
        const Comp = (props: ToastProps) => {
            return (
                <Alert variant={type} onClose={props.onClose}>
                    {message}
                </Alert>
            );
        };

        Comp.displayName = 'toast';
        return Comp;
    };

    const onCompleted = action => {
        toast.success(Messages[action],toastOpt);
        refetch();
    };

    const onActionError = action => {
        toast.error(ErrorMessages[action],toastOpt);
        refetch();
    };

    const [deleteProppant] = useMutation(DELETE_PROPPANT, {
        onCompleted: () => onCompleted('delete'),
        onError: () => onActionError('delete'),
    });

    const [addProppant] = useMutation(ADD_PROPPANT, {
        onCompleted: () => onCompleted('create'),
        onError: () => onActionError('create'),
    });

    const [editProppant] = useMutation(EDIT_PROPPANT, {
        onCompleted: () => onCompleted('update'),
        onError: () => onActionError('update'),
    });

    const onCreate = () => {
        setForm(null);
        setCreateDialogVisible(true);
    };

    const onEdit = useCallback((record: any) => {
        setForm(record);
        setCreateDialogVisible(true);
    }, []);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onDelete = useCallback(async (record: any) => {
        const variables = { input: { proppantId: record.proppantId } };
        await deleteProppant({ variables });
    }, []);

    const saveProppant = useCallback(async (data: any) => {
        if (data.proppantId) {
            const { proppantId, proppantName, extSystemReference } = data;
            const variables = {
                input: { id: proppantId, proppantValues: { proppantName, extSystemReference } },
            };
            await editProppant({ variables });
        } else {
            const variables = { input: { ...data } };
            await addProppant({ variables });
        }
    }, []);

    if (loading) {
        return <Loading />;
    }

    if (error) {
        return <Error error={error} />;
    }
    let propants: Proppant[] = [];

    if (data && data.getAllProppants && data.getAllProppants.length !== 0) {
        data.getAllProppants.forEach((element: Proppant | null): void => {
            if (element !== null) {
                propants.push(element);
            }
        });
    }

    const [firstRecord = {}] = propants;
    if (searchText) {
        const caseSearch = (searchText || '').toLowerCase();
        propants = propants.filter(record => {
            const { proppantName = '', extSystemReference } = record;
            return (
                (proppantName && proppantName.toLowerCase().includes(caseSearch)) ||
                (extSystemReference && extSystemReference.toLowerCase().includes(caseSearch))
            );
        });
    }
    document.title = 'Proppants';
    return (
        <>
            <GridView
                columns={getColums(firstRecord)}
                canEdit={canEditProppant}
                onEdit={onEdit}
                onDelete={onDelete}
                onCreate={onCreate}
                data={propants}
                onSearch={setSearchText}
            />
            <ToastContainer />
            <AddEditProppant
                show={createDialogVisible}
                setShow={flag => setCreateDialogVisible(flag)}
                saveChanges={saveProppant}
                form={form}
            />
        </>
    );
};

export default Proppants;

